export const appConfig = {
  region: 'ap-northeast-1',
  userPoolId: 'ap-northeast-1_lZ70xtiwN',
  userPoolClientId: '2cfu61ompucv7up71fjfldv2tc',
  apiUrl: 'https://oms.develop.probud.io',
  wssUrl: '',
};
